<script setup lang="ts">
import LoadingBar from "../LoadingBar.vue";
</script>

<template>
  <div class="menu-list-loading-bar">
    <LoadingBar />
  </div>
</template>

<style lang="scss" scoped>
.menu-list-loading-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
